module.exports = __webpack_public_path__ + "img/art2.0a616972.gif";